<template>
  <div>
    <Grid
      :service="service"
      :route_grid_path="`/moderator/grid`"
      order_column="created_at"
      direction="desc">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="title" sort-key="title">{{ $t('newsletter.title') }}</vs-th>
        <vs-th key="group_news_name" sort-key="group_news_name">{{ $t('group_news.group') }}</vs-th>
        <vs-th key="comments_count" :sort-key="null" class="no-sort">Comentários (total)</vs-th>
        <vs-th key="likes_count" :sort-key="null" class="no-sort">Curtidas</vs-th>
        <vs-th key="views_count" :sort-key="null" class="no-sort">Visualizações</vs-th>
        <vs-th key="comments_without_moderator_count" :sort-key="null" class="no-sort">Comentários (sem moderador)</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in props.data"
          :class="{ 'bg-light-warning': tr.comments_without_moderator_count > 0 }">
          <vs-td width="5%" key="id">
            <div> {{ tr.id }} </div>
          </vs-td>
          <vs-td width="40%" key="title">
            <div> {{ tr.title }}</div>
          </vs-td>
          <vs-td width="10%" key="group_news_name">
            <div> {{ tr.group_news_name }}</div>
          </vs-td>
          <vs-td width="10%" key="comments_count">
            <div> {{ tr.comments_count }} </div>
          </vs-td>
          <vs-td width="10%" key="likes_count">
            <div> {{ tr.data.like }} </div>
          </vs-td>
          <vs-td width="10%" key="views_count">
            <div> {{ tr.data.view }} </div>
          </vs-td>
          <vs-td width="10%" key="comments_without_moderator_count">
            <div
              :class="{ 'text-warning font-semibold': tr.comments_without_moderator_count > 0 }">
              {{ tr.comments_without_moderator_count }}
            </div>
          </vs-td>
          <vs-td width="10%">
            <div class="flex flex-row gap-2">
                <feather-icon
                  v-permission="'newsletters_moderator.handling'"
                  @click="moderate(props.data[indextr].id)"
                  icon="CheckIcon"
                  class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                  v-tooltip.top="{content: 'Detalhar e Moderar',delay: { show: 100, hide: 100 }}"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>

import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'


import NewsletterService from '@/services/api/NewsletterService'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton
  },
  data: () => ({
    selected: [],
    service: null
  }),
  methods: {
    moderate(id) {
      this.$router.push({
        name: 'newsletter-moderator-comments',
        params: {
          id: id
        }
      })
    },
  },
  beforeMount() {
    this.service = NewsletterService.build(this.$vs)
  }
}
</script>


